import React, { useState, useEffect } from "react";
import { useLoading } from "context/LoadingContext";
import { useAlert } from "context/AlertContext";
import { fetchDashboardData } from "Service/ApiService"; // Replace with your API
// import { getAllASnStatusData } from "Service/ApiService"; // Replace with your API

const DashboardController = () => {
  const [dashboardData, setDashboardData] = useState([]);
  // const [appointmentData, setAppointmentData] = useState([]);
  const { setLoading } = useLoading();
  const { showAlert } = useAlert();
  const vendorDetails = JSON.parse(localStorage.getItem("vendor"));
  const vendorCode = vendorDetails ? vendorDetails.vendorCode : null;

  // Fetch dashboard data on mount
  useEffect(() => {
    getDashboardData();
    // getAppointmentData();
  }, []);

  const getDashboardData = async () => {
    try {
      setLoading(true);
      const response = await fetchDashboardData(vendorCode);
      if (response && response.success) {
        setDashboardData(response.data || []);
      } else {
        showAlert("Failed to fetch dashboard data!", { icon: "error", title: "Error" });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert("Something went wrong while fetching dashboard data!", {
        icon: "error",
        title: "Error",
      });
    }
  };

  // const getAppointmentData = async () => {
  //   try {
  //     const response = await getAllASnStatusData(vendorCode, "", 0, 500);
  //     if (response && response.success === "true") {
  //       setAppointmentData(response.ASNStatusList || []);
  //     }
  //   } catch (error) {
  //     console.error("Appointment calendar fetch error", error);
  //   }
  // };

  return {
    dashboardData,
    // appointmentData,
  };
};

export default DashboardController;
